import { render, staticRenderFns } from "./regionMoreDialog.vue?vue&type=template&id=4ecd3f9e&scoped=true"
import script from "./regionMoreDialog.vue?vue&type=script&lang=js"
export * from "./regionMoreDialog.vue?vue&type=script&lang=js"
import style0 from "./regionMoreDialog.vue?vue&type=style&index=0&id=4ecd3f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd3f9e",
  null
  
)

export default component.exports